document.addEventListener('DOMContentLoaded', () => {
  const main = document.getElementById('MainContent');
  if (!main) return;

  const sections = Array.from(main.children).filter(el => el.nodeType === 1);
  if (!sections.length) return;

  // mark sections so CSS can target them
  sections.forEach(s => s.classList.add('section-appear'));

  // ensure images are lazy when possible
  sections.forEach(s => {
    s.querySelectorAll('img:not([loading])').forEach(img => img.setAttribute('loading', 'lazy'));
  });

  const io = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      el.classList.add('is-visible');

      // Start autoplaying videos when visible (best-effort)
      el.querySelectorAll('video').forEach(video => {
        try {
          // only try if muted or no audio
          if (video.muted || video.defaultMuted) video.play().catch(() => {});
        } catch (e) {}
      });

      observer.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  sections.forEach(s => io.observe(s));
});
